import React from 'react';
import { Pagination } from 'react-bootstrap';

const CustomPagination = ({ totalPages, selectedPage, handlePageChange }) => {
    return (
        <Pagination>
            {[...Array(totalPages)]?.map((_, index) => (
                <Pagination.Item 
                    key={index + 1} 
                    active={index + 1 === selectedPage} 
                    onClick={() => handlePageChange(index + 1)}
                >
                    {index + 1}
                </Pagination.Item>
            ))}
        </Pagination>
    );
};

export default CustomPagination;
